import axios from "axios";

let baseUrl = undefined;

const CSRF_COOKIE_NAME = 'XSRF-TOKEN'
const CSRF_HEADER_NAME = 'HTTP_X_XSRF_TOKEN'

const session = axios.create({
    xsrfCookieName: CSRF_COOKIE_NAME,
    xsrfHeaderName: CSRF_HEADER_NAME,
    baseURL: baseUrl
})

export default session

